import { CanvasTexture, RepeatWrapping, Vector2 } from "three";
import { onBeforeUnmount, onMounted, ref } from "vue";

export default function useGridTexture (color: string) {
  const texture = ref<CanvasTexture>();
  const canvas = ref<HTMLCanvasElement>();

  onMounted(() => {
    canvas.value = document.createElement("canvas");
    canvas.value.width = 100;
    canvas.value.height = 100;

    draw(color);

    texture.value = new CanvasTexture(canvas.value);
    texture.value.wrapS = RepeatWrapping;
    texture.value.wrapT = RepeatWrapping;
    texture.value.repeat.set(100, 100);
    texture.value.offset = new Vector2(0.5, 0.5);
  });

  onBeforeUnmount(() => {
    texture.value?.dispose();
  });

  function draw (color: string) {
    if (!canvas.value) {
      return;
    }

    const context = canvas.value.getContext("2d");

    if (context) {
      context.fillStyle = color;
      context.fillRect(0, 0, canvas.value.width, canvas.value.height);

      context.beginPath();
      context.strokeStyle = "#ffffff";
      context.setLineDash([2, 4]);
      context.lineWidth = 2;
      context.moveTo(0, 0);
      context.lineTo(canvas.value.width, 0);
      context.moveTo(0, 0);
      context.lineTo(0, canvas.value.height);
      context.stroke();

      if (texture.value) {
        texture.value.needsUpdate = true;
      }
    }
  }

  return {
    gridCanvas: canvas,
    gridTexture: texture,
    draw,
  };
}
